export default __webpack_public_path__ + "static/media/controlClose24.375726e7.svg";